import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renders the piracy-notice content block as a notification bar at the bottom
 * of the page. The content block HTML carries its own styling and the anchor
 * to the piracy-notice PDF. Renders nothing when no content is available.
 */
export default function PiracyNotice({ htmlContent }) {
  if (!htmlContent) return null;

  // Sticky notification bar: stays pinned to the bottom of the viewport while
  // scrolling, and parks above the footer at the end of the page (its sticky
  // range is bounded by the wrapping container in HeaderFooterLayout, which
  // excludes the footer).
  //
  // The authored content block ships with its own positioning (typically
  // position: fixed), which would break the sticky behaviour and overlay the
  // footer. Force its root element back into normal flow so our sticky wrapper
  // controls placement.
  return (
    <div
      className="piracy-notice sticky bottom-0 z-50 w-full [&>*]:!static [&>*]:!bottom-auto [&>*]:!top-auto [&>*]:!left-auto [&>*]:!right-auto"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}

PiracyNotice.propTypes = {
  htmlContent: PropTypes.string,
};

PiracyNotice.defaultProps = {
  htmlContent: null,
};
